import { Typography } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { usePublishFixtureTask } from "hooks/useFixtureTaskApi";
import { usePublishSeasonTask } from "hooks/useSeasonTaskApi";
import { useState } from "react";
import { useIntl } from "react-intl";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
};

export const PublishButton = ({ entityId, season, fixture }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const { mutateAsync: publishSeasonTask, isPending: isSeasonTaskPublishing } = usePublishSeasonTask();
  const { mutateAsync: publishFixtureTask, isPending: isFixtureTaskPublishing } = usePublishFixtureTask();

  const disabled = fixture ? !fixture.isRegistrationOpened : !season.isRegistrationOpened;

  const onApprove = () => {
    if (fixture) {
      publishFixtureTask({
        entityId: entityId,
        seasonId: fixture.seasonId,
        fixtureId: fixture.fixtureId,
      });
    } else if (season) {
      publishSeasonTask({ entityId: entityId, seasonId: season.seasonId });
    }

    setOpenModal(false);
  };

  return (
    <>
      <DefaultButton
        disabled={disabled}
        onClick={() => setOpenModal(true)}
        icon={<i className="fa-solid fa-paper-plane"></i>}
      >
        {formatMessage({ id: "button.publish" })}
      </DefaultButton>
      {openModal && (
        <DefaultModal
          width={undefined}
          open={openModal}
          onOk={onApprove}
          title={formatMessage(
            { id: "publishConfirmationModal.title" },
            {
              objectType: formatMessage({
                id: fixture ? "objectType.fixture" : "objectType.season",
              }),
            }
          )}
          onCancel={() => setOpenModal(false)}
          cancelText={formatMessage({ id: "button.no" })}
          okButtonProps={{
            loading: isSeasonTaskPublishing || isFixtureTaskPublishing,
          }}
          cancelButtonProps={{
            disabled: isSeasonTaskPublishing || isFixtureTaskPublishing,
          }}
          okText={formatMessage({ id: "button.yes" })}
        >
          <Typography.Paragraph>{formatMessage({ id: "publishConfirmationModal.content" })}</Typography.Paragraph>
        </DefaultModal>
      )}
    </>
  );
};
